/**
 * Pricing-lead triage score derived from age + contacted state.
 *
 * Hot   → fresh, unreached  (< 15 min)   — call immediately
 * Warm  → still fresh       (< 2 h)      — reach today
 * Cold  → stale, unreached  (2 h+)       — auto-nudge already fired
 * Done  → marked contacted                — parked
 *
 * Timings match the backend PRICING_NUDGE_AFTER_MINUTES threshold.
 */
export function scoreFor(lead) {
  if (lead.contacted_at) {
    return { key: "done", label: "Contacted", tone: "bg-[#E9F5EC] text-[#2f7d3f] border-[#2f7d3f]/30" };
  }
  const created = lead.created_at ? new Date(lead.created_at).getTime() : Date.now();
  const ageMin = (Date.now() - created) / 60000;
  if (ageMin < 15) {
    return { key: "hot", label: "Hot", tone: "bg-[#F8ECEC] text-[#a13a3a] border-[#a13a3a]/30" };
  }
  if (ageMin < 120) {
    return { key: "warm", label: "Warm", tone: "bg-gold/20 text-[#8B6F1F] border-gold/40" };
  }
  return { key: "cold", label: "Cold", tone: "bg-[#EDEAE4] text-[#6B6B6B] border-black/15" };
}
